"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var removeTrailingZeroes = function removeTrailingZeroes(str) {
  return str.replace(/(\d)0+$/, "$1");
};

var removeLeadingPlus = function removeLeadingPlus(str) {
  return str.replace(/^\+/, "");
};

var ScientificNotationNumber = function ScientificNotationNumber(_ref) {
  var value = _ref.value,
      accuracy = _ref.accuracy,
      style = _ref.style;

  if (value >= 0.1 && value < 100000 || value === 0) {
    return _react["default"].createElement("span", null, value);
  }

  var scientificNotationString = value.toExponential(accuracy);
  var mantissaExponent = scientificNotationString.split("e");
  var mantissa = removeTrailingZeroes(mantissaExponent[0]);
  var exponent = removeLeadingPlus(mantissaExponent[1]);
  return _react["default"].createElement("span", {
    style: style
  }, +mantissa !== 1 ? "".concat(mantissa, " \xD7 ") : "", "10", _react["default"].createElement("span", {
    style: {
      verticalAlign: "super"
    }
  }, exponent));
};

ScientificNotationNumber.propTypes = {
  value: _propTypes["default"].number.isRequired,
  accuracy: _propTypes["default"].number,
  style: _propTypes["default"].object
};
ScientificNotationNumber.defaultProps = {
  accuracy: 4,
  style: {}
};
var _default = ScientificNotationNumber;
exports["default"] = _default;